<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>
    <basic-table
      v-if="optionDef"
      :items="optionDef"
      :fields="optionDefFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal
      :editItem="selectedOptionDef"
      :isEdit="isEdit"
      :optionDef="optionDef"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      isEdit: false,
      optionDefFields: [
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'code', label: this.$i18n.t('Code'), sortable: true},
        {key: 'type', label: this.$i18n.t('Type'), sortable: true},
        {key: 'space', label: this.$i18n.t('Space'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedOptionDef: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.isEdit = false
      this.selectedOptionDef = {
        'name': '',
        'code': '',
        'space': 'dhcp6',
        'type': 'ipv6-address',
        'array': false,
        'record-types': '',
        'encapsulate': ''
      }
      this.$root.$emit('bv::show::modal', 'modalEditOptionDef', '#btnShow')
    },
    editItem (item) {
      this.isEdit = true
      this.selectedOptionDef = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditOptionDef', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Option-def"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/DHCPV6']))
      let del = JSON.parse(JSON.stringify(this.optionDef))
      del = del.filter((value) => {
        return value.numOptionDef !== item.numOptionDef
      })
      let DHCP = {
        'is_test_only': false,
        'loop_count_timeout': 35,
        'config': {}
      }
      DHCP.config = copy.arguments
      DHCP.config.Dhcp6['option-def'] = del
      let response = this.$store.dispatch('Settings/SAVE_DHCPV6', DHCP)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$store.dispatch('Settings/SAVE_CONFIG_DHCPV6')
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_DHCPV6')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    optionDef () {
      let DHCPV6 = JSON.parse(JSON.stringify(this.$store.getters['Settings/DHCPV6']))
      let copy = DHCPV6.arguments.Dhcp6['option-def']
      let numOptionDef = 0
      for (let el of copy) {
        el.numOptionDef = ++numOptionDef
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_DHCPV6')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/DHCPv6/optionDef/main.vue